import { ClaimProductsAndModalities, ClaimMultiStepFormReferenceData } from '@/constants/BenefitQuoteMockApiData';
import BenefitQuotesServicesMock from '../BenefitQuotes/BenefitQuotesServicesMock';
import AbstractClass from './ClaimsAbstractServices';
import { AwaitResponse } from '../../utils/MockUtils';

export default class ClaimsServices extends AbstractClass {
  static getLandingPageReferenceData() {
    const mockData = {
      referenceData: {
        claimInformationText: {
          informationText: `<p>Things you should know about claiming online:</p><ul>
          <li>Defence Health requires you to hold onto those receipts for at least 2 years for auditing purposes.</li>
          <li>For some high cost services we may ask you to upload your receipt when submitting your claim.</li>
          <li>The total amount payable for claims in a single day cannot exceed $500.</li>
          <li>Benefits are paid  according to our General claiming conditions and the limitations of your cover.</li>
          <li>Extras providers need to be registered with their professional body and in the case of approved alternative therapies, recognised by the Australian Regional Health Group.</li>
          <li>Hospital claims cannot be made online. <a href="/$memberNumber$/support/contact-us" target="_blank">Get in touch</a> if you need assistance with a hospital claim.</li>
        </ul>`,
        },
        claimCalloutText: {
          informationText: `<h2>Make a claim</h2>\r\n<p>Please ensure your <a href="/$memberNumber$/member-selection/$thisPersonCode$$thisPersonName$">claim account details</a> are up to date before you start.</p><p>Any benefits payable will be deposited into your nominated account within 2 business days.</p>`,
        },
        claimCalloutIcon: {
          informationText: '~/assets/public/images/icon_add.svg',
        },
      },
      coverStartDate: '2020-08-02',
    };

    // give space between `thisPersonCode` and `thisPersonName` string token to build correct url path
    const stringifiedData = JSON.stringify(mockData).replace(/\$thisPersonCode\$\$thisPersonName\$/g, '$thisPersonCode$ $thisPersonName$');
    const tokenSwappedData = stringifiedData.tokenSwap().personCodeTokenSwap().memberNameTokenSwap();
    return AwaitResponse(JSON.parse(tokenSwappedData));
  }

  /**
   * Returns a mock list of all claims from OHI for a given policy.
   * Used for getting claims summary list.
   */
  static getClaimsSummary() {
    const status = {
      APPROVED: 'Approved',
      PAID: 'Paid',
      REJECTED: 'Rejected',
      PENDING: 'Pending',
    };

    const mockReturnData = {
      claims: [
        {
          claimId: `cla${3031}`,
          personCodes: ['2922'],
          personNames: ['Jude Anthony'],
          claimTypes: ['Ambulance Modality'],
          submittedDate: '2023-06-01',
          serviceDate: '2023-02-01',
          status: status.APPROVED,
          benefitsPaid: 100.15,
        },
        {
          claimId: `cla${3011}`,
          personCodes: ['2922'],
          personNames: ['Jude Anthony', "Nick D'Amico"],
          claimTypes: ['Ante & Postnatal Modality'],
          submittedDate: '2023-06-06',
          serviceDate: '2023-02-01',
          status: status.REJECTED,
          benefitsPaid: 121.2,
        },
        {
          claimId: `cla${3012}`,
          personCodes: ['2922'],
          personNames: ['Jude Anthony'],
          claimTypes: ['Ante & Postnatal Modality'],
          submittedDate: '2023-06-07',
          serviceDate: '2023-02-01',
          status: status.PAID,
          benefitsPaid: 100.35,
        },
        {
          claimId: `cla${3022}`,
          personCodes: ['2922'],
          personNames: ['Jude Anthony'],
          claimTypes: ['Acupuncture Modality'],
          submittedDate: '2023-06-07',
          serviceDate: '2023-02-01',
          status: status.PENDING,
          benefitsPaid: 10.15,
        },
        {
          claimId: `cla${3014}`,
          personCodes: ['2922'],
          personNames: ['Jude Anthony'],
          claimTypes: [null],
          submittedDate: '2023-06-07',
          serviceDate: '2023-02-01',
          status: status.APPROVED,
          benefitsPaid: 52.63,
        },
        {
          claimId: `cla${3015}`,
          personCodes: ['2922'],
          personNames: ['Jude Anthony'],
          claimTypes: ['Acupuncture Modality'],
          submittedDate: '2023-06-07',
          serviceDate: '2023-02-01',
          status: status.APPROVED,
          benefitsPaid: 100,
        },
        {
          claimId: `cla${3016}`,
          personCodes: ['2922'],
          personNames: ['Jude Anthony'],
          claimTypes: ['Acupuncture Modality'],
          submittedDate: '2023-06-07',
          serviceDate: '2023-02-01',
          status: status.REJECTED,
          benefitsPaid: 100,
        },
        {
          claimId: `cla${3017}`,
          personCodes: ['2922'],
          personNames: ['Jude Anthony'],
          claimTypes: ['Acupuncture Modality'],
          submittedDate: '2023-06-07',
          serviceDate: '2023-02-01',
          status: status.PAID,
          benefitsPaid: 124.12,
        },
        {
          claimId: `cla${3018}`,
          personCodes: ['2922'],
          personNames: ['Jude Anthony'],
          claimTypes: ['Ante & Postnatal Modality'],
          submittedDate: '2023-05-08',
          serviceDate: '2023-02-01',
          status: status.APPROVED,
          benefitsPaid: 36.25,
        },
        {
          claimId: `cla${3019}`,
          personCodes: ['2922'],
          personNames: ['Jude Anthony'],
          claimTypes: ['Ante & Postnatal Modality'],
          submittedDate: '2023-05-04',
          serviceDate: '2023-02-01',
          status: status.PENDING,
          benefitsPaid: 315.76,
        },
        {
          claimId: `cla${3028}`,
          personCodes: ['2922'],
          personNames: ['Rupeshkumar Kadam'],
          claimTypes: ['Ante & Postnatal Modality'],
          submittedDate: '2023-06-09',
          serviceDate: '2023-02-01',
          status: 'in progress',
          benefitsPaid: 200.12,
        },
        {
          claimId: `cla${3025}`,
          personCodes: ['2922'],
          personNames: ["Nick D'Amico"],
          claimTypes: [null],
          submittedDate: '2023-07-10',
          serviceDate: '2022-02-01',
          status: status.PAID,
          benefitsPaid: 110.2,
        },
      ],
    };

    return AwaitResponse(mockReturnData);
  }

  /**
   * Returns a mock list of members, their products and modalities and payment details.
   */
  static getMembersProductsAndModalities() {
    return AwaitResponse(ClaimProductsAndModalities);
  }

  /**
   * Returns a mock list of multi-step form related reference data from Kentico.
   */
  static getMultiStepFormReferenceData() {
    return AwaitResponse(ClaimMultiStepFormReferenceData);
  }

  /**
   * Return a mock list of providers
   */
  static getProvidersForSelectedModality() {
    return BenefitQuotesServicesMock.getProvidersForSelectedModality();
  }

  /**
   * Returns a mock list of services
   */
  static getServicesForSelectedModality() {
    return BenefitQuotesServicesMock.getServicesForSelectedModality();
  }

  static submitFile(memberNumber, category, accessingPersonCode, file, dateTimestamp, serviceId, serviceDate, index) {
    if (index !== 5) {
      return AwaitResponse({
        StorageContainer: 'document',
        FileName: '<file name>.<file extension>',
        ETAG: 'string',
        blobName: `this/is/blob/name/${file.name}`,
        blobMetadata: {
          metadataField: 'string',
        },
        blobIndexTags: {
          memberNumber: 'memberNumber', // only if "is-member" request header was "true" or was not given
          personCode: 'personCode', // only if "is-member" request header was "true" or was not given
          contactId: 'contactId', // only if "is-member" request header was "false"
        },
      });
    }
    return AwaitResponse({ failed: true }, true);
  }

  static submitClaim() {
    const response = {
      claimId: '00000001',
      claimDate: '2020-09-25',
      claimStatus: 'pending',
      personCode: '2000',
      memberFullName: 'Jude Anthony',
      claimSuccessFlag: true,
      modality: {
        claimTypeCode: 'CLAIM TYPE',
        claimTypeName: 'Claim name',
        isUnlimited: false,
        annualBenefitLimit: 100,
        consumption: 200,
        totalBenefitsPayable: 150,
      },
      claimMessage: [
        {
          code: 'claim message code',
          message: 'this is claim message',
        },
      ],
      claimLines: [
        {
          serviceDate: '2020-03-27',
          serviceId: '651',
          serviceName: 'Hard coating - single',
          providerFee: 200,
          benefitsPayable: 97.5,
          benefitsClaimable: 97.5,
          messageLine: [
            {
              code: 'claim line message line code',
              message: 'Claim message goes here - reasons why the claim was rejected goes here.',
            },
          ],
          uploadedFiles: ['filename.jpg', 'anotherfilename.jpg'],
        },
        {
          status: null,
          serviceDate: '2020-03-27',
          toothid: '000',
          serviceId: '100',
          serviceName: 'Hard coating - single',
          providerFee: 100,
          benefitsPayable: 52.5,
          benefitsClaimable: 97.5,
          messageLine: [
            {
              code: 'claim line message line code',
              message: 'Claim message goes here - reasons why the claim was rejected goes here.',
            },
          ],
          uploadedFiles: ['filename.jpg'],
        },
        {
          status: 'approved',
          serviceDate: '2020-03-19',
          serviceId: '1234',
          serviceName: 'Dental',
          toothId: 'T001',
          providerFee: 100.0,
          benefitsPayable: 50,
          benefitsClaimable: 50,
          messageLine: [
            {
              code: 'claim line message line code 2',
              message: 'Claim message goes here - reasons why the claim was rejected goes here. 2',
            },
          ],
        },
      ],
      provider: {
        providerId: '0000000A',
        lastName: 'Gail Schwartz',
      },
    };
    return AwaitResponse(response);
  }

  static getClaimDetails() {
    const response = {
      claimId: '00000001',
      claimDate: '2020-09-25',
      claimStatus: 'pending',
      personCodes: ['2408'],
      memberFullNames: ['Some name1', 'Some name2'],
      claimSuccessFlag: true,
      modality: {
        claimTypeCode: 'CLAIM TYPE',
        claimTypeName: 'Claim name',
        isUnlimited: false,
        annualBenefitLimit: 105.79,
        consumption: 200.02,
        totalBenefitsPayable: 144.22,
      },
      claimMessage: [
        {
          code: 'claim message code',
          message: 'this is claim message',
        },
      ],
      claimLines: [
        {
          serviceDate: '2020-03-27',
          serviceId: '651',
          serviceName: 'Hard coating - single',
          providerFee: 200,
          benefitsPayable: 97.5,
          benefitsClaimable: 97.5,
          messageLine: [
            {
              code: 'claim line message line code',
              message: 'Claim message goes here - reasons why the claim was rejected goes here.',
            },
          ],
          uploadedFiles: ['filename.jpg', 'anotherfilename.jpg'],
        },
        {
          status: null,
          serviceDate: '2020-03-27',
          toothid: '000',
          serviceId: '100',
          serviceName: 'Hard coating - single',
          providerFee: 100,
          benefitsPayable: 52.5,
          benefitsClaimable: 97.5,
          messageLine: [
            {
              code: 'claim line message line code',
              message: 'Claim message goes here - reasons why the claim was rejected goes here.',
            },
          ],
          uploadedFiles: ['filename.jpg'],
        },
        {
          status: 'approved',
          serviceDate: '2020-03-19',
          serviceId: '1234',
          serviceName: 'Dental',
          toothId: 'T001',
          providerFee: 100.0,
          benefitsPayable: 50,
          benefitsClaimable: 50,
          messageLine: [
            {
              code: 'claim line message line code 2',
              message: 'Claim message goes here - reasons why the claim was rejected goes here. 2',
              severity: 'F',
            },
          ],
        },
        {
          status: 'approved',
          serviceDate: '2020-03-19',
          serviceId: '4561',
          serviceName: 'Dental',
          toothId: '12',
          providerFee: 100.0,
          benefitsPayable: 50,
          benefitsClaimable: 50,
          messageLine: [
            {
              code: 'claim line message line code 2',
              message: 'Claim message goes here - reasons why the claim was rejected goes here. 2',
            },
          ],
        },
        {
          status: 'approved',
          serviceDate: '2020-03-19',
          serviceId: '6658',
          serviceName: 'Dental',
          toothId: '00',
          providerFee: 100.0,
          benefitsPayable: 50,
          benefitsClaimable: 50,
          messageLine: [
            {
              code: 'claim line message line code 2',
              message: 'Claim message goes here - reasons why the claim was rejected goes here. 2',
            },
          ],
        },
      ],
      provider: {
        providerId: '0000000A',
        firstName: 'Furtnam',
        middleName: 'Middle',
        lastName: 'Rastnam',
        addressLine1: '11 Exhibition St',
        addressLine2: '',
        addressLine3: '',
        suburb: 'MELBOURNE',
        state: 'VIC',
        postcode: '3000',
      },
      claimsAccount: {
        accountId: '3444',
        accountHolderName: 'First Last',
        bsb: '233 - 332',
        accountNumber: '3243 4343',
      },
    };
    return AwaitResponse(response);
  }

  static submitSnapAndSend() {
    return AwaitResponse({
      status: 201,
    });
  }
}
